import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { FirebaseObjectObservable,
         FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'show-forum',
  templateUrl: './show-forum.component.html',
  styleUrls: ['./show-forum.component.scss'],
  animations: [slide]
})
export class ShowForumComponent implements OnInit {
  forumObservable: FirebaseObjectObservable<any>;
  forum: any;
  selectedPost: any;
  posts: FirebaseListObservable<any[]>;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService
  ) { }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.forumObservable = this.dbService.getForum(params['key']);
      this.forumObservable.subscribe(forum => {
        this.forum = forum;
      });
      this.posts = this.dbService.getPosts(params['key']);
    });
  }

  showPost(key: string) {
    this.router.navigate([`/forums/${this.forum.$key}/posts/${key}`]);
  }

  onAddPostClicked() {
    this.selectedPost = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onEditPostClicked(post, event) {
    event.stopPropagation();
    this.selectedPost = post;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeletePostClicked(post, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedPost = post;
  }

  onConfirmDeletePost() {
    this.onHideDeleteModal()
    this.dbService.deletePost(this.forum.$key, this.selectedPost.$key);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/forums/show-forum/show-forum.component.ts